import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('admin@example.com');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    setLoading(true);
    setError('');
    e.preventDefault();
    try {
      const result = await login(email, password);
      console.log('Login response:', result);
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    } catch (err) {
      console.error('Login error:', err);
      const errorMessage = err.response?.data?.error || err.message || 'Login failed';
      setError(`Error: ${errorMessage}`);
    }
  };

  return (
    <div className="auth-card">
      <h2 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '30px' }}>Task Management System</h2>
      {error && (
        <div style={{ 
          color: 'white', 
          backgroundColor: '#e74c3c', 
          padding: '10px', 
          borderRadius: '4px', 
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          {error}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: '5px', color: '#34495e' }}>
            Email:
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ 
                display: 'block', 
                width: '100%', 
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #bdc3c7',
                marginTop: '5px'
              }}
              required
            />
          </label>
        </div>
        <div style={{ marginTop: 12, textAlign: 'right' }}>
          <a href="/forgot-password" style={{ color: '#2c3e50', textDecoration: 'underline' }}>Forgot password?</a>
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={{ display: 'block', marginBottom: '5px', color: '#34495e' }}>
            Password:
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ 
                display: 'block', 
                width: '100%', 
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #bdc3c7',
                marginTop: '5px'
              }}
              required
              placeholder="Enter Password123"
            />
          </label>
        </div>
        <button 
          type="submit" 
          disabled={loading}
          style={{ 
            width: '100%', 
            padding: '12px',
            backgroundColor: '#2c3e50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1
          }}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      <div style={{ marginTop: '20px', textAlign: 'center', color: '#7f8c8d', fontSize: '14px' }}>
        Default Login Credentials:
        <br />
        Email: admin@example.com
        <br />
        Password: Password123
      </div>
    </div>
  );
}